import { Title } from "../../../components";
import { Container } from "./styles";

import img from '../../../assets/rinsContraste/img2.png'
import img3 from '../../../assets/rinsContraste/img3.png'

export default function (){
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Scout em AP e Perfil com linhas de referência (fase cortical).</Title>
                    
                    <section className="mt-2 p-3">
                        <img className="img-fluid" src={img} alt="Linhas Referencia" />
                    </section>

                    <section className="mt-2 p-3">
                        <h6 className="text-center font-weight-bold">Descrição da série axial com contraste I.V. (aquisição).</h6>

                        <p>
                            <strong>Recon:</strong> Recon 1 <br />
                        
                            <strong>Anotação:</strong> Axial com contraste I.V. trifásico
(Fase cortical, medular e excretora) <br />
                        
                            <strong>Espessura:</strong> 2.5 / 2.5mm<br />
                            
                            <strong>Filtro:</strong> Std<br />
                        </p>

                        <p>
                            <strong>Recon:</strong> Recon 2 <br />
                        
                            <strong>Anotação:</strong> Volume fase cortical <br />
                        
                            <strong>Espessura:</strong> 1.25 / 1mm<br />
                            
                            <strong>Filtro:</strong> Soft<br />
                        </p>

                        <p>
                            <strong>Recon:</strong> Recon 3 <br />
                        
                            <strong>Anotação:</strong> Volume fase medular <br />
                        
                            <strong>Espessura:</strong> 1.25 / 1mm<br />
                            
                            <strong>Filtro:</strong> Soft<br />
                        </p>

                        <p>
                            <strong>Recon:</strong> Recon 4 <br />
                        
                            <strong>Anotação:</strong> Volume fase excretora <br />
                        
                            <strong>Espessura:</strong> 1.25 / 1mm<br />
                            
                            <strong>Filtro:</strong> Soft<br />
                        </p>
                        <img className="img-fluid" src={img3} alt="Linhas Referencia" />
                    </section>
                </div>
            </div>
        </Container>
    )
}